module.exports = __webpack_public_path__ + "static/media/M1-27-Unicorjik-cod146.01c5eaac.png";